import styled from "styled-components";

const ErrorMessage = styled.p`
    font-size: 0.6875rem;
    color: #f85149;
    margin-top: 0.3125rem;
`;

export default ErrorMessage;
